export default class EventoConstants {

  public static readonly ITEM_CONTRIBUIR = {
    id: 'contribuir',
    name: 'Contribuir',
    icon: 'pi pi-pencil',
    order: 0
  };

  public static readonly ITEM_DISPOSITIVO = {
    id: 'contribuir',
    name: 'Tópicos',
    icon: 'pi pi-pencil',
    order: 0
  };

  public static readonly ITEM_SESSAO = {
    id: 'sessao-presencial',
    name: 'Sessão',
    icon: 'pi pi-folder',
    order: 1,
  };

  public static readonly ITEM_CONTRIBUICAO_PUBLICADA = {
    id: 'contribuicao-publicada',
    name: 'Contribuições Publicadas',
    icon: 'pi pi-file',
    order: 2
  };

  public static readonly ITEM_NORMA_DEFINITIVA = {
    id: 'norma-definitiva',
    name: 'Norma Definitiva',
    icon: 'pi pi-folder',
    order: 3
  };

  public static readonly ITEM_DEGRAVACAO = {
    id: 'degravacao',
    name: 'Degravação',
    icon: 'pi pi-file-pdf',
    order: 4
  };

    public static readonly ITEM_DOCUMENTACAO = {
    id: 'documentacao',
    name: 'Documentação',
    icon: 'pi pi-file-pdf',
    order: 5
  };

  public static readonly LISTA_DEFAULT = [
    EventoConstants.ITEM_CONTRIBUICAO_PUBLICADA,
    EventoConstants.ITEM_NORMA_DEFINITIVA,
    EventoConstants.ITEM_DEGRAVACAO,
    EventoConstants.ITEM_DOCUMENTACAO
  ];

  public static readonly FILE_TYPES = [
    'jpg', 'jpeg', 'png', 'bmp', 'doc', 'xls',
    'ppt', 'mpp', 'docx', 'xlsx', 'pptx', 'odt',
    'ods', 'odp', 'pdf', 'txt', 'rtf', 'dwg', 'rar', 'zip', '7z'
  ];

  public static readonly MAX_FILE_UPLOAD = 2147483648;

  public static montarLista(temSessao: boolean, eventoEncerrado: boolean) {
    const lista: any = [...EventoConstants.LISTA_DEFAULT];
    
    if (temSessao) {
      lista.push(EventoConstants.ITEM_SESSAO);
    }
    if (eventoEncerrado) {
      lista.push(EventoConstants.ITEM_DISPOSITIVO);
    } else {
      lista.push(EventoConstants.ITEM_CONTRIBUIR);
    }
    lista.sort((a: any, b: any) => a.order - b.order);
    return [...lista];
  }


}
